import React, { useState, useEffect } from 'react';
import { Popover } from 'antd';
import { NotificationPanel } from './components';
import {
  NotificationCtx,
  useNotification,
} from './components/NotificationProvider';
import './NotificationCenter.style.scss';

const NotificationCenter = () => {
  const [isActive, setIsActive] = useState(false);
  const iconClass = isActive
    ? 'icon-notification-fill'
    : 'icon-notification-outline';

  const content = <NotificationPanel />;
  const notificationContextValue = useNotification() || {};

  useEffect(() => {
    // if (!isActive) {
    notificationContextValue.reorderUnreadList &&
      notificationContextValue.reorderUnreadList();
    // }
  }, [isActive]);

  const isShowDot = Boolean(
    (notificationContextValue.threadData || []).filter((v) => !v.readStatus)
      .length,
  );
  const dotClass = isShowDot ? '' : 'notification-without-dot';

  return (
    <NotificationCtx.Provider
      value={{ setPanelVisible: setIsActive, ...notificationContextValue }}
    >
      <div className="notification-center-wrap">
        <Popover
          content={content}
          trigger="click"
          visible={isActive}
          onVisibleChange={setIsActive}
          placement="bottomRight"
          getPopupContainer={() =>
            document.getElementsByClassName('app-header')[0] || document.body
          }
          overlayClassName="notification-center-popover"
        >
          <span
            className={`appkiticon notification-icon ${dotClass} ${iconClass}`}
          />
        </Popover>
      </div>
    </NotificationCtx.Provider>
  );
};

export default NotificationCenter;
